import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { BoldSyntax } from '../../common/util';
import { StringsMapping } from '../../common/strings';

function CouponSetup(props) {
  const { newI18n, coupon } = props;

  const { cost, value } = coupon;

  const stepOneImgClass = 'coupon-step-one-image';
  const stepTwoImgClass = 'coupon-step-two-image';
  const couponText = useMemo(
    () =>
      newI18n.getString(StringsMapping.Coupon_Title, { value }),
    [newI18n, value]
  );

  const stepOneText = useMemo(
    () =>
      newI18n.getString(StringsMapping.Coupon_Step1),
    [newI18n]
  );
  const stepTwo = useMemo(
    () =>
      newI18n.getString(StringsMapping.Coupon_Step2),
    [newI18n]
  );

  const stepTwoText = useMemo(
    () =>
      newI18n.getString(StringsMapping.Coupon_Step2_Detail, { cost, value }),
    [cost, newI18n, value]
  );


  return (
    <React.Fragment>
      <div className="coupon-text">{couponText}</div>
      <div className="coupon-steps-container">
        <div className="first-step step">
          <div className="step-image-container">
            <div className={`step-image ${stepOneImgClass}`} />
          </div>
          <div className="step-text">
            <BoldSyntax template={stepOneText} />
          </div>
        </div>
        <div className="second-step step">
          <div className="step-image-container">
            <div className={`step-image ${stepTwoImgClass}`} />
          </div>
          <div className="step-text">
            <BoldSyntax template={stepTwo} />
            {stepTwoText}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

CouponSetup.defaultProps = {
};

CouponSetup.propTypes = {
  newI18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  coupon: PropTypes.shape({
    cost: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  }).isRequired,
};

export default CouponSetup;
